import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=461d55d2&"
import script from "./Region.vue?vue&type=script&lang=ts&"
export * from "./Region.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports